import { isWebserviceAuthorizationFailure } from './webserviceErrors';

/**
 * Installs one authorization boundary at the lowest shared webservice request
 * seam. KeaWebServiceClient convenience methods delegate to prepareRequest, so
 * this covers both the product runtime and legacy cloud-only service adapters.
 */
export function installWebserviceAuthRecovery(client, onAuthFailure) {
  if (!client || typeof client.prepareRequest !== 'function'
    || typeof onAuthFailure !== 'function') return client;

  const prepareRequest = client.prepareRequest.bind(client);
  let recoveryStarted = false;

  client.prepareRequest = async (...args) => {
    try {
      return await prepareRequest(...args);
    } catch (error) {
      if (isWebserviceAuthorizationFailure(error) && !recoveryStarted) {
        recoveryStarted = true;
        try {
          onAuthFailure(error);
        } catch (recoveryError) {
          // Navigation/storage recovery must never replace the request error.
        }
      }
      throw error;
    }
  };

  return client;
}

export default installWebserviceAuthRecovery;
